document.addEventListener('DOMContentLoaded', () => {
  const heroSliderEl = document.querySelector(
    ".hero-slider-container.swiper-container"
  );
  if (heroSliderEl) {
    const heroSlider = new Swiper(heroSliderEl, {
      loop: true,
      loopedSlides: 3,
      slidesPerView: "auto",
      centeredSlides: true,
      slideToClickedSlide: true,
      observer: true,
      pagination: {
        el: heroSliderEl.querySelector(".hero-slider-pagination"),
        type: "bullets",
        clickable: true,
      },
    });
  }
});
 
